import React from 'react'

const MenuCategory = ({name, children, showBorder = false}) => {
	return (
		<React.Fragment>
			<section className='space-y-4'>
				{name !== '' ? (
					<p className='text-[#6D6D6D] text-xs'>{name}</p>
				) : showBorder && (
					<div className={`content-[""] border-t border-[#E5E5E5]`} />
				)}
				<div className='flex flex-col'>
					{ children }
				</div>
			</section>
		</React.Fragment>
	)
}

export default MenuCategory